import { render, staticRenderFns } from "./pdfPreview.vue?vue&type=template&id=2ebc5de2&scoped=true&"
import script from "./pdfPreview.vue?vue&type=script&lang=js&"
export * from "./pdfPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebc5de2",
  null
  
)

export default component.exports